import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';

@Component({
  selector: 'app-certificate-policy',
  templateUrl: './certificate-policy.component.html'
})
export class CertificatePolicyComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit() {
  }

  @ViewChildren("focus") focus;
  ngAfterViewInit() {
    setTimeout(_ => this.focus.first.nativeElement.focus(), 200);
  }
}
